/**
 * Created by pzf on 2018/10/31
 *
 */
import DynamicForm from './DynamicForm';
export default DynamicForm;
//# sourceMappingURL=index.js.map
